/**
 * Frontend mirror of backend/constants/pricing.py — kept in sync manually.
 *
 * Revision history:
 *   - iter48 (P52/P53): Initial 4-tier catalog.
 *   - iter93.3 (Feb 2026): Starter $29→$49 / 400→1,500 credits;
 *     Pro AI caps 1,500→5,000; Business AI caps 4,000→10,000.
 */
export const PRICING_TIERS = [
  {
    slug: 'starter',
    name: 'Starter',
    price_cents: 4900,
    price_label: '$49',
    billing_cycle: '/month',
    ai_credit_cap: 1500,
    seats: 1,
    stripe_checkout: true,
    cta: 'Start Starter Trial',
    description: 'Get started with 1,500 AI calls per month.',
    features: [
      '1,500 auto-run AI calls / month',
      'All Data Sources & Signals',
      'Email + Social sharing',
      'PDF / CSV exports',
      '1 seat',
    ],
  },
  {
    slug: 'pro',
    name: 'Pro',
    price_cents: 9900,
    price_label: '$99',
    billing_cycle: '/month',
    ai_credit_cap: 5000,
    seats: 2,
    stripe_checkout: true,
    cta: 'Start Pro Trial',
    description: 'For small teams — share 5,000 AI calls across up to 2 seats.',
    features: [
      '5,000 auto-run AI calls / month (shared)',
      'Up to 2 team seats (shared workspace)',
      'Priority refresh cycles',
      'Everything in Starter',
      'Priority email support',
    ],
  },
  {
    slug: 'business',
    name: 'Business',
    price_cents: 29900,
    price_label: '$299',
    billing_cycle: '/month',
    ai_credit_cap: 10000,
    seats: 5,
    stripe_checkout: true,
    cta: 'Start Business Trial',
    description: 'For growing teams — 10,000 AI calls shared across 5 seats.',
    features: [
      '10,000 auto-run AI calls / month (shared)',
      'Up to 5 team seats (shared workspace)',
      'Everything in Pro',
      'Dedicated onboarding',
      'SLA-backed support',
    ],
  },
  {
    slug: 'enterprise',
    name: 'Enterprise',
    price_cents: 0,
    price_label: 'Custom',
    billing_cycle: 'per quote',
    ai_credit_cap: -1,
    seats: -1,
    stripe_checkout: false,
    contact_email: 'sales@dotbox.ai',
    cta: 'Contact sales',
    description: 'Tailored credits, seats, and SLAs for large organizations.',
    features: [
      'Custom AI credit volume / month',
      'Custom team seat count',
      'Everything in Business',
      'Dedicated account manager',
      'Custom SLA + onboarding',
      'Volume discounts',
    ],
  },
];

export const tierBySlug = (slug) =>
  PRICING_TIERS.find((t) => t.slug === (slug || 'starter').toLowerCase())
  || PRICING_TIERS[0];

export const formatCap = (cap) =>
  cap === -1 ? 'Custom' : `${cap.toLocaleString()} / month`;

export const formatSeats = (seats) =>
  seats === -1 ? 'Custom' : String(seats);
